import withStyles from 'isomorphic-style-loader/lib/withStyles';

import React from 'react';
import Panel from 'react-bootstrap/lib/Panel';

import References from '../../../components/Help/Demographics/References';

import s from './ExpertsSection.scss';

class ExpertsSection extends React.Component {
  render() {
    return (
      <React.Fragment>
        <Panel>
          <Panel.Heading>Experts</Panel.Heading>
          <Panel.Body>
            <p>
              Shadower provides a fantastic avenue for experts and professionals
              to share their passion, knowledge and expertise with a wider
              audience in a more intimate, meaningful and impactful way through
              face-to-face interactions. Experts will be able to organically
              grow their personal brand by building a loyal, local support base,
              all the while expanding their financial reach. A 2017 PayScale
              study found that the average salary of a small business owner in
              America is approximately $73,000 per year but total earning can
              range from $30,000 - $182,000 per year.
              <span className={s.cite}>18</span> $73,000 is not very much when
              you subtract mortgage payments, car payments, children, insurance
              and education. Shadower can bolster the small-business market by
              helping business owners earn supplemental income for sharing their
              knowledge.
            </p>

            <p>
              Besides providing additional income, Shadower also has the
              potential to help experts and professionals explore new career
              paths. A booming economy typically results in more job turnover as
              there are simply more job opportunities nationwide. A
              peer-to-peer, career-focused platform like Shadower can greatly
              assist job seekers.
            </p>

            <p>
              So, how much can an expert expect to make on Shadower? Until we
              launch, we simply don't know, but for now, we can use tutoring as
              a starting point for projections. Approximately 150,000 of
              Colorado households with children under 18 years of age have paid
              for tutoring, so there is certainly demand for in-person
              education. On average, tutoring in Colorado costs $39 per session,
              so using that figure, experts who teach once per week can expect
              supplemental income over $1,800 each year.
            </p>
            <References
              referenceList={
                <div>
                  <ol>
                    <li>
                      <a
                        href="http://youthtruthsurvey.org/wp-content/uploads/2016/01/YouthTruth-Learning-From-Student-Voice-College-and-Career-Readiness-2016.pdf"
                        rel="noreferrer noopener"
                        target="_blank"
                      >
                        YouthTruth Student Survey (2016)
                      </a>
                      ,&nbsp;
                      <i>
                        Most High Schoolers Feel Unprepared for College and
                        Careers.
                      </i>
                    </li>

                    <li>
                      <a
                        href="https://www.fastweb.com/career-planning/articles/how-to-arrange-and-conduct-a-job-shadow"
                        rel="noreferrer noopener"
                        target="_blank"
                      >
                        FastWeb (2018)
                      </a>
                      ,&nbsp;
                      <i>How to Manage and Conduct a Job Shadow.</i>
                    </li>

                    <li>
                      <a
                        href="https://www.statista.com/statistics/524033/parents-children-tutoring-pay/"
                        rel="noreferrer noopener"
                        target="_blank"
                      >
                        HSBC (2018)
                      </a>
                      ,&nbsp;
                      <i>
                        Share of parents who have paid or would pay for tutoring
                        for their child in selected countries in 2015.
                      </i>
                    </li>

                    <li>
                      <a
                        href="https://nces.ed.gov/pubs2018/2018434.pdf"
                        rel="noreferrer noopener"
                        target="_blank"
                      >
                        NCES (2017)
                      </a>
                      ,&nbsp;
                      <i>
                        College students tend to change majors when they find
                        the one they really love.
                      </i>
                    </li>

                    <li>
                      <a
                        href="https://www.statista.com/statistics/731339/factors-that-would-have-helped-students-to-feel-more-prepared-for-their-careers-us/"
                        rel="noreferrer noopener"
                        target="_blank"
                      >
                        Hanover Research, McGraw-Hill (2017)
                      </a>
                      ,&nbsp;
                      <i>
                        Share of factors that would have made students feel more
                        prepared for their careers in the United States in 2017.
                      </i>
                    </li>

                    <li>
                      <a
                        href="https://www.chronicle.com/article/What-s-Wrong-With-Required/242727"
                        rel="noreferrer noopener"
                        target="_blank"
                      >
                        The Chronicle of Higher Education (2018)
                      </a>
                      ,&nbsp;
                      <i>What's Wrong with Required Internships?</i>
                    </li>

                    <li>
                      <a
                        href="https://www.statista.com/statistics/673316/top-fields-for-internship-positions/"
                        rel="noreferrer noopener"
                        target="_blank"
                      >
                        New York Times, Burning Glass (2016)
                      </a>
                      ,&nbsp;
                      <i>
                        Occupational fields with the largest number of
                        internship postings in the United States from September
                        2015 to October 2016.
                      </i>
                    </li>

                    <li>
                      <a
                        href="https://www.burning-glass.com/research-project/internships-2015/"
                        rel="noreferrer noopener"
                        target="_blank"
                      >
                        Burning Glass (2015)
                      </a>
                      ,&nbsp;
                      <i>
                        No Experience Necessary? The State of American
                        Internships 2015.
                      </i>
                    </li>

                    <li>
                      <a
                        href="https://www.statista.com/statistics/782547/number-of-schools-offering-occupational-education-us-by-state/"
                        rel="noreferrer noopener"
                        target="_blank"
                      >
                        NCES (2013)
                      </a>
                      ,&nbsp;
                      <i>
                        Number of postsecondary schools offering occupation
                        education in the U.S. in 2013, by state.
                      </i>
                    </li>

                    <li>
                      <a
                        href="https://highered.colorado.gov/Data/InstSelect.aspx"
                        rel="noreferrer noopener"
                        target="_blank"
                      >
                        CHDE (2017)
                      </a>
                      ,&nbsp;
                      <i>Search Colleges and Universities.</i>
                    </li>

                    <li>
                      <a
                        href="https://nces.ed.gov/programs/digest/d17/tables/dt17_105.50.asp?current=yes"
                        rel="noreferrer noopener"
                        target="_blank"
                      >
                        NCES (2016)
                      </a>
                      ,&nbsp;
                      <i>
                        Number of educational institutions, by level and control
                        of institution: Selected years, 1980-81 through 2015-16.
                      </i>
                    </li>

                    <li>
                      <a
                        href="https://www.statista.com/statistics/782528/number-of-schools-offering-occupational-education-us-by-school-type/"
                        rel="noreferrer noopener"
                        target="_blank"
                      >
                        NCES (2014)
                      </a>
                      ,&nbsp;
                      <i>
                        Number of postsecondary schools offering occupational
                        education in the U.S. from 2000 to 2014, by school type.
                      </i>
                    </li>

                    <li>
                      <a
                        href="https://www.statista.com/statistics/334116/reasons-for-us-online-non-degree-classes-by-age/"
                        rel="noreferrer noopener"
                        target="_blank"
                      >
                        Online Computer Library Center (2014)
                      </a>
                      ,&nbsp;
                      <i>
                        U.S. online learner reasons for taking online non-degree
                        classes as of January 2014, by age.
                      </i>
                    </li>

                    <li>
                      <a
                        href="https://www.statista.com/statistics/334033/us-online-classes-tutorial-usage-income-levels/"
                        rel="noreferrer noopener"
                        target="_blank"
                      >
                        Online Computer Library Center (2014)
                      </a>
                      ,&nbsp;
                      <i>
                        Share of U.S. online population who have taken online
                        classes or tutorials as of January 2014, by income
                        levels.
                      </i>
                    </li>

                    <li>
                      <a
                        href="https://www.statista.com/statistics/334040/us-online-classes-tutorial-usage-education-levels/"
                        rel="noreferrer noopener"
                        target="_blank"
                      >
                        Online Computer Library Center (2014)
                      </a>
                      ,&nbsp;
                      <i>
                        Share of U.S. online population who have taken online
                        classes or tutorials as of January 2014, by education
                        levels.
                      </i>
                    </li>

                    <li>
                      <a
                        href="https://www.statista.com/statistics/184236/us-online-classes-tutrial-usage-age/"
                        rel="noreferrer noopener"
                        target="_blank"
                      >
                        Online Computer Library Center (2014)
                      </a>
                      ,&nbsp;
                      <i>
                        Share of U.S. online population who have taken online
                        classes or tutorials as of January 2014, by age.
                      </i>
                    </li>

                    <li>
                      <a
                        href="https://www.statista.com/statistics/862627/us-employment-market-sources-of-new-opportunities-for-jobseekers/"
                        rel="noreferrer noopener"
                        target="_blank"
                      >
                        Jobvite (2018)
                      </a>
                      ,&nbsp;
                      <i>
                        Main sources to learn of new opportunities for U.S. job
                        seekers in 2018.
                      </i>
                    </li>

                    <li>
                      <a
                        href="https://www.payscale.com/research/US/Job=Small_Business_Owner/Salary"
                        rel="noreferrer noopener"
                        target="_blank"
                      >
                        REF (2017)
                      </a>
                      ,&nbsp;
                      <i>Small Business Owner Salary.</i>
                    </li>
                  </ol>
                </div>
              }
              referenceTitle="References"
            />
          </Panel.Body>
        </Panel>
      </React.Fragment>
    );
  }
}

export default withStyles(s)(ExpertsSection);
